import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../common/html/element'
import { Icon } from '../../common/html/icon'
import { COMPONENTS } from '../../routers/constants'
import classes from './index.module.scss'

export const Header = () => {
  return (
    <Element className={classes.header} style={{ borderColor: '#E5E5E8' }}>
      <Element
        className={classes.title}
        style={{ fontSize: 24, color: '#0553A5' }}
      >
        <Translate value="alerts.ALERTS_LIST" />
      </Element>

      <Link to={COMPONENTS.alerts.components.alertSetting.route}>
        <Element
          className={classes.settingBtn}
          style={{ backgroundColor: '#2C73E8' }}
        >
          <Element style={{ color: '#FFFFFF' }}>
            <Translate value="alerts.ALERT_SETTINGS" />
          </Element>
          <Icon
            className="icon-arrow-right"
            style={{ color: '#FFFFFF', fontSize: 8 }}
          />
        </Element>
      </Link>
    </Element>
  )
}
